import React, { useState } from "react";
import axios from "axios";
import Notify from "../../utils/useNotify";

export default function Newsletter({ t }) {
  const token = localStorage.getItem("token");
  const localhost = process.env.REACT_APP_LOCALHOST;
  const [form, setForm] = useState({ nl_full_name: "", nl_email: "", nl_phone: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nl_full_name && !form.nl_email && !form.nl_phone) {
      Notify("warning", t("newsletter.warning") || "Please fill in at least one field!");
      return;
    }
    try {
      await axios.post(`${localhost}store-newsletter-subscription`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      Notify("success", t("newsletter.success") || "Subscription added successfully!");
      setForm({ nl_full_name: "", nl_email: "", nl_phone: "" });
    } catch (error) {
      Notify("error", t("newsletter.error") || "Something went wrong, please try again.");
      // console.error(error);
    }
  };

  return (
    <div>
      <h2 className="font-semibold uppercase text-sm mb-3 border-b border-gray-700 pb-1">{t("newsletter.title")}</h2>
      <p className="text-gray-400 text-sm mb-4">{t("newsletter.text")}</p>
      <form className="space-y-3" onSubmit={handleSubmit}>
        <input type="text" name="nl_full_name" placeholder={t("newsletter.fullname")} value={form.nl_full_name} onChange={handleChange} className="w-full rounded-md bg-white text-black text-sm px-3 py-2 outline-none focus:ring-2 focus:ring-gray-600" />
        <input type="email" name="nl_email" placeholder={t("newsletter.email")} value={form.nl_email} onChange={handleChange} className="w-full rounded-md bg-white text-black text-sm px-3 py-2 outline-none focus:ring-2 focus:ring-gray-600" />
        <input type="tel" name="nl_phone" placeholder={t("newsletter.phone")} value={form.nl_phone} onChange={handleChange} className="w-full rounded-md bg-white text-black text-sm px-3 py-2 outline-none focus:ring-2 focus:ring-gray-600" />
        <button type="submit" className="w-full bg-white text-black font-semibold text-sm rounded-md py-2 transition-colors duration-200 hover:bg-gray-200">
          {t("newsletter.subscribe")}
        </button>
      </form>
    </div>
  );
}
